query DocumentPools(
  $first: Int
  $after: Cursor
  $orderBy: [DocumentPoolsOrderBy!]
) {
  documentPools(first: $first, after: $after, orderBy: $orderBy) {
    nodes {
      id
      name
      description
      defaultDirectoryTypeId
      defaultDirectoryTypes {
        id
        description
      }
      defaultDocumentTypeId
      defaultDocumentTypes {
        id
        documentType
      }
      _documentFileCount {
        availableDocuments
        selectedDocuments
      }
      isShareableDefault
      isCreateCopyWithSelection
      isRetainedWithSelection
      isBusinessUnitSelector
      isDepartmentSelector
      isDocumentTypeSelector
      defaultBusinessUnitId
      defaultBusinessUnits {
        id
        name
      }
      defaultDepartmentId
      defaultDepartments {
        id
        name
        _isDeletable
      }
      userGroupId
      userGroups {
        id
        name
      }
      _isProtected
      _isModified
      _isUpdatable
      _isDeletable
      _rowTimestamp
      _isNotesExist
      notesByEntityId {
        nodes {
          id
          noteComment
          _rowTimestamp
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
  }
  # currentUserProfile {
  #   isAdministrator
  #   departmentId
  # }
}
